<!-- 评审-详情 -->
<template>
  <div id="detail_simple" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">评审详情</div>
    <!-- 基础信息 -->
    <div
      class="form_detail"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <div v-for="(item, i) in keyItems" :key="i">
        <div>{{ item.title }}</div>
        <div
          v-if="item.type == 'status'"
          class="nowrap"
          :class="
            item.class_status ? item.class_status[simpleItem[item.key]] : ''
          "
        >
          {{
            item.text_status[simpleItem[item.key]]
              ? item.text_status[simpleItem[item.key]]
              : "--"
          }}
        </div>
        <div v-else-if="item.type == 'money'" class="nowrap">
          {{ `￥${common.formatNumber(simpleItem[item.key])}` }}
        </div>
        <div v-else-if="item.type == 'time'" class="nowrap">
          {{
            simpleItem[item.key]
              ? moment(simpleItem[item.key]).format("YYYY-MM-DD HH:mm:ss")
              : "--"
          }}
        </div>
        <div v-else-if="item.type == 'file'" class="nowrap">
          <div v-if="simpleItem[item.key]?.length > 0">
            <div
              v-for="(f, i) in simpleItem[item.key]"
              :key="i"
              class="file nowrap"
              @click="handleFileViewing(f)"
            >
              {{ f?.name }}
            </div>
          </div>
          <div v-else style="color: #909399">暂无附件</div>
        </div>
        <el-button
          v-else-if="item.type == 'btn'"
          type="text"
          @click="
            item.title.indexOf('自评') > -1
              ? openSelfResult()
              : openCertificate()
          "
          style="margin-left: 15px"
          :disabled="item.title === '评审证书' && certificateLoading"
          >查看{{ item.title }}</el-button
        >
        <div v-else>
          {{ simpleItem[item.key] ? simpleItem[item.key] : "--" }}
        </div>
      </div>
    </div>
    <!-- 表单按钮 -->
    <div class="absoluteGrop">
      <el-button plain @click="$router.go(-1)">返 回</el-button>
    </div>
    <!-- 预览组件 -->
    <PreviewFile ref="previewFile"></PreviewFile>
    <CreateCardPDF ref="createCardPDF"></CreateCardPDF>
  </div>
</template>
<script>
import moment from "moment";
import PreviewFile from "../../components/file-preview.vue";
import CreateCardPDF from "../../components/createCardPDF.vue";

export default {
  name: "detail_simple",
  components: { PreviewFile, CreateCardPDF },
  data() {
    return {
      loading: true,
      moment: moment,
      simpleItem: {},
      certificateLoading: false,
      // 信息字段
      keyItems: [
        { title: "用户名称", key: "userName" },
        { title: "账号用户名", key: "registerMail" },
        { title: "提交时间", key: "selfAssessmentTime", type: "time" },
        { title: "目前所涉及的行业", key: "category" },
        {
          title: "评审类型",
          key: "type",
          type: "status",
          text_status: ["", "日常评审", "年度评审"],
        },
        { title: "分配时间", key: "createTime", type: "time" },
        { title: "评审专家", key: "expertName" },
        {
          title: "评审状态",
          key: "status",
          type: "status",
          text_status: [
            "",
            "企业待自评",
            "专家待分配",
            "专家评审中",
            "已截止",
            "已完成",
          ],
          class_status: ["", "orange", "orange", "orange", "red", "green"],
        },
        { title: "评审完成时间", key: "expertReviewTime", type: "time" },
        { title: "自评分数", key: "selfScore" },
        { title: "自评报告", key: "", type: "btn" },
        { title: "评价依据", key: "paperName" },
        { title: "专家评审得分", key: "appraisalResult" },
        { title: "设备管理成熟度", key: "evaluate" },
        { title: "星级", key: "starLevel" },
        { title: "整改意见", key: "expertOpinion" },
        { title: "评审证书", key: "", type: "btn" },
      ],
    };
  },
  created() {
    this.getInfo();
  },
  computed: {
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  methods: {
    // 获取信息
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/reviewRecord/userRecordInfo`, {
          id: this.$route.query.id,
          userId: this.$route.query.userId,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.simpleItem = res.data.data;
            this.loading = false;
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 预览
    handleFileViewing(file) {
      this.$refs.previewFile.openDrawer([file]);
    },
    // 查看自评
    openSelfResult() {
      window.open(
        `${this.report}/reportSeif.html?selfId=${this.simpleItem.selfId}`,
        "_blank"
      );
      this.common.reportsNumber(1);
      // this.$router.push({
      //   path: '/initiaSelf',
      //   query: { selfId: this.simpleItem.selfId, isEdit: true },
      // });
    },
    // 查看评审报告
    openReport() {
      // window.open(`${this.report}/report.html?selfId=' + this.simpleItem.id, '_blank')
    },
    // 查看评审证书
    async openCertificate() {
      // 防止重复点击
      if (this.certificateLoading) return;

      try {
        this.certificateLoading = true;
        this.$message.info("正在生成证书PDF...");

        // 调用PDF生成方法并传递selfId
        await this.$refs.createCardPDF.downloadPdf(this.simpleItem.selfId);

        this.$message.success("证书生成成功！");
      } catch (error) {
        console.error("生成证书失败:", error);
        this.$message.error("生成证书失败，请重试");
      } finally {
        // 无论成功还是失败，都重置loading状态
        this.certificateLoading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.form_detail {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  color: #111928;
  height: calc(100vh - 200px);
  overflow: auto;
  > div {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #e5e7eb;
    > div {
      padding: 8px 15px;
    }
    > div:first-child {
      color: #6b7280;
      width: 15vh;
      position: relative;
      flex-shrink: 0;

      &::after {
        content: "";
        position: absolute;
        right: 0px;
        width: 2px;
        height: 60%;
        top: 20%;
        font-size: 20px;
        background: #e5e7eb;
      }
    }
    .file {
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
}
.smallTitle {
  padding: 8px 15px;
  color: #6b7280;
  width: 200px;
}
</style>
